<ng-template #dialogTemplate class="relative">
  <div *ngIf="currentDialog === 'EOI'" class="pt-[16px]">
    <app-eoi-sections
      (closeModalEvent)="handleCloseModal($event)"
      [currentEOISavedData]="currentEOISavedData"
    ></app-eoi-sections>
  </div>
  <div *ngIf="currentDialog === 'PQQ'" class="pt-[16px]">
    <app-pqq-sections
      (closeModalEvent)="handleCloseModal($event)"
    ></app-pqq-sections>
  </div>
  <div *ngIf="currentDialog === 'applicant-sections'">
    <app-applicant-pqq-sections
      (closeModalEvent)="handleCloseModal($event)"
      [pqqReferenceDates]="pqqInputData"
      [isEdit]="isEdit"
    ></app-applicant-pqq-sections>
  </div>

  <!-- ITT DEV side sections -->
  <div *ngIf="currentDialog === 'itt-wrapper'" class="pt-[16px]">
    <app-itt-wrapper
      [isEdit]="isEdit"
      (closeModalEvent)="handleCloseModal($event)"
    ></app-itt-wrapper>
  </div>

  <!-- RFQ DEV side sections -->
  <div *ngIf="currentDialog === 'rfq-wrapper'" class="pt-[16px]">
    <app-rfq-wrapper
      [isEdit]="isEdit"
      (closeModalEvent)="handleCloseModal($event)"
    ></app-rfq-wrapper>
  </div>

  <!-- RFQ Tender sections -->
  <div *ngIf="currentDialog === 'rfq-tenderer-wrapper'" class="pt-[16px]">
    <app-rfq-section-dialogs
      (closeModalEvent)="handleCloseModal($event)"
      [tendererResponse]="rfpResponseData"
    ></app-rfq-section-dialogs>
  </div>

  <!-- Close Icon -->
  <div style="position: absolute; top: 10px; right: 36px; z-index: 50">
    <img
      src="assets/icons/cross-icon.svg"
      (click)="closeDialog()"
      alt="cross icon"
      class="cursor-pointer !fixed"
    />
  </div>
</ng-template>
